/*
(function ($) {
  $(document).ready(function ($) {
    $('.btn').each(function () {
      var $this = $(this),
        $text = $(this).html();

      $this.html('<span></span>' + $text);
    });
  });
})(jQuery);
*/
